import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';

import { LutienOrganizationsGetResponseDTO } from './dto/lutien-organizations.get.response.dto';

export class LutienOrganizationsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/organizations`, client.getTimeout());
  }

  async get(request?: { settings?: RetrySettings }): Promise<LutienOrganizationsGetResponseDTO> {
    return (
      await this.client.get<LutienOrganizationsGetResponseDTO>(
        ``,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: request?.settings,
        },
      )
    ).data;
  }
}
